import { SVGProps } from 'react';

export const ChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M45.5 45.5h-8.667v-39H45.5v39ZM30.333 45.5h-8.666V18.816h8.666V45.5ZM15.167 45.5H6.5V31.132h8.667v14.37Z'
      clipRule='evenodd'
    />
  </svg>
);
